import globalStore from '@/services/global.state';
import {errorLog} from '@/utils';
import {goTo} from '@/utils/route';
import {
  FissionV4Open,
  FissionV4Progress,
  getFissionV4Progress,
} from './fission-v4.service';
import {openReferEarnEntryCashGift} from './home/refer-earn-wheel-card/entry-cash-gift-modal';

let pendingEntryProgress: FissionV4Progress | undefined;
let pendingEntryCashGiftFlow = false;
let pendingEntryCashGiftAmountIncrease = false;
let openingReferEarnInvitation: Promise<void> | undefined;

const REFER_EARN_ROUTE_NAME = 'ReferEarn';
const REFER_EARN_ROUTE_PATH = 'refer-earn';
const REFER_EARN_TAB_ENTRY_PATH = 'index/referral';

export const notifyReferEarnInvitationReady = () => undefined;

export const isReferEarnInvitationRoute = (routeOrUri?: string) => {
  const nextRouteOrUri = routeOrUri?.trim();
  if (!nextRouteOrUri) {
    return false;
  }

  let routeName = nextRouteOrUri;
  if (nextRouteOrUri.startsWith('route:')) {
    const routePayload = nextRouteOrUri.slice('route:'.length).trim();
    try {
      routeName = JSON.parse(routePayload)?.routeName || '';
    } catch {
      routeName = routePayload;
    }
  }

  const normalizedRouteName = routeName
    .split(/[?#]/)[0]
    .replace(/^\/+|\/+$/g, '')
    .toLowerCase();

  return (
    normalizedRouteName === REFER_EARN_ROUTE_NAME.toLowerCase() ||
    normalizedRouteName === REFER_EARN_ROUTE_PATH ||
    normalizedRouteName === REFER_EARN_TAB_ENTRY_PATH ||
    normalizedRouteName === 'invite'
  );
};

const getNormalizedBrowserPath = () => {
  if (typeof window === 'undefined') {
    return '';
  }

  return window.location.pathname.replace(/^\/+|\/+$/g, '').toLowerCase();
};

const goToReferEarnPage = () => {
  goTo(REFER_EARN_ROUTE_NAME);
};

const scheduleReferEarnPageNavigation = () => {
  goToReferEarnPage();

  if (typeof window === 'undefined') {
    return;
  }

  window.setTimeout(goToReferEarnPage, 0);
  window.setTimeout(() => {
    if (getNormalizedBrowserPath() === REFER_EARN_TAB_ENTRY_PATH) {
      goToReferEarnPage();
    }
  }, 240);
};

export const consumeReferEarnEntryProgress = () => {
  const progress = pendingEntryProgress;
  pendingEntryProgress = undefined;
  return progress;
};

export const consumeReferEarnEntryCashGiftFlow = () => {
  const pending = pendingEntryCashGiftFlow;
  pendingEntryCashGiftFlow = false;
  return pending;
};

export const hasPendingReferEarnEntryCashGiftAmountIncrease = () =>
  pendingEntryCashGiftAmountIncrease;

export const consumeReferEarnEntryCashGiftAmountIncrease = () => {
  const pending = pendingEntryCashGiftAmountIncrease;
  pendingEntryCashGiftAmountIncrease = false;
  return pending;
};

const prepareEntryCashGiftNavigation = (nextRound: FissionV4Open) => {
  pendingEntryProgress = {
    ...nextRound,
    status: 'IN_PROGRESS',
    currentAmount: 0,
  };
  pendingEntryCashGiftFlow = true;
  pendingEntryCashGiftAmountIncrease = true;
  return Promise.resolve();
};

const openReferEarnInvitationFlow = async () => {
  if (!globalStore.token) {
    pendingEntryProgress = undefined;
    pendingEntryCashGiftFlow = false;
    pendingEntryCashGiftAmountIncrease = false;
    goToReferEarnPage();
    return;
  }

  let progress: FissionV4Progress | undefined;
  globalStore.globalLoading.next(true);
  try {
    progress = await getFissionV4Progress();
  } catch (error) {
    errorLog('refer earn entry progress check failed', error);
  } finally {
    globalStore.globalLoading.next(false);
  }

  if (progress?.status === 'WAIT_OPEN') {
    await openReferEarnEntryCashGift(progress, prepareEntryCashGiftNavigation);
    scheduleReferEarnPageNavigation();
    return;
  }

  pendingEntryProgress = progress;
  pendingEntryCashGiftFlow = false;
  pendingEntryCashGiftAmountIncrease = false;
  goToReferEarnPage();
};

export function openReferEarnInvitation() {
  if (!openingReferEarnInvitation) {
    openingReferEarnInvitation = openReferEarnInvitationFlow().finally(() => {
      openingReferEarnInvitation = undefined;
      globalStore.globalLoading.next(false);
    });
  }

  return openingReferEarnInvitation;
}

export function openReferEarnInvitationRoute(routeName?: string) {
  if (!isReferEarnInvitationRoute(routeName)) {
    return false;
  }

  openReferEarnInvitation();
  return true;
}
